import { render, staticRenderFns } from "./TempDetail.vue?vue&type=template&id=5e52fced&"
import script from "./TempDetail.vue?vue&type=script&lang=js&"
export * from "./TempDetail.vue?vue&type=script&lang=js&"
import style0 from "./TempDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports